import React from 'react'
import EditOffer from './EditOffer'
import MaintenanceSummary from './MaintenanceSummaryPage'
import OfferApprovals from './OfferApprovalListPage'
import OfferParticipation from './OfferParticipationListPage'
import OfferSourcingDecisions from './OfferSourcingDecisionListPage'
import OfferVendorRFQs from './OfferVendorRFQListPage'

import { OfferStage, OfferType } from '../constants'
import MyOfferPage from './MyOfferPage'
import OfferListPage from './OfferListPage'
import OfferPRApprovalListPage from './OfferPRApprovalListPage'
import OfferTaskDashboard from './OfferTaskDashboard'
import MySourcingPage from './MySourcingPage'
import OfferGCPRApprovalListPage from './OfferGCPRApprovalListPage'
import OfferGCPRMaterialListPage from './OfferGCPRMaterialListPage'

const OfferBreadcrumb = () => <>{`Offer Detail`}</>

const offerRoutes = [
  {
    breadcrumb: 'My Offers',
    path: 'my',
    element: <MyOfferPage />,
  },
  {
    breadcrumb: 'My Sourcing',
    path: 'mySourcing',
    element: <MySourcingPage />,
  },
  {
    breadcrumb: 'Offer (Maintenance)',
    path: 'offerMaintenance',
    element: <OfferListPage offerStage={OfferStage.QUOTATION} offerType={OfferType.MAINTENANCE} isEQuotation={false} />,
  },
  {
    breadcrumb: 'Offer (Project)',
    path: 'offerProject',
    element: <OfferListPage offerStage={OfferStage.QUOTATION} offerType={OfferType.PROJECT} isEQuotation={false} />,
  },
  {
    breadcrumb: 'Offer (Project E Quotation)',
    path: 'offerProjectEQuotation',
    element: <OfferListPage offerStage={OfferStage.QUOTATION} offerType={OfferType.PROJECT} isEQuotation={true} />,
  },

  {
    breadcrumb: 'Booking (Maintenance)',
    path: 'bookingMaintenance',
    element: <OfferListPage offerStage={OfferStage.BOOKING} offerType={OfferType.MAINTENANCE} isEQuotation={false} />,
  },
  {
    breadcrumb: 'Booking (Project)',
    path: 'bookingProject',
    element: <OfferListPage offerStage={OfferStage.BOOKING} offerType={OfferType.PROJECT} isEQuotation={false} />,
  },
  {
    breadcrumb: 'Booking (Project)',
    path: 'bookingProjectEQuotation',
    element: <OfferListPage offerStage={OfferStage.BOOKING} offerType={OfferType.PROJECT} isEQuotation={true} />,
  },

  {
    breadcrumb: 'Approvals',
    path: 'approvals',
    element: <OfferApprovals />,
  },

  {
    breadcrumb: 'Maintenance Summary',
    path: 'maintenanceSummary',
    element: <MaintenanceSummary />,
  },
  {
    breadcrumb: 'My Offers',
    path: 'participations',
    element: <OfferParticipation />,
  },
  {
    breadcrumb: 'Sourcing Decisions',
    path: 'sourcingDecisions',
    element: <OfferSourcingDecisions />,
  },
  {
    breadcrumb: 'Vendor RFQs',
    path: 'vendorRFQs',
    element: <OfferVendorRFQs />,
  },
  {
    breadcrumb: 'PR Approvals',
    path: 'pr-approvals',
    element: <OfferPRApprovalListPage />,
  },
  {
    breadcrumb: 'GCPR Approvals',
    path: 'gcpr-approvals',
    element: <OfferGCPRApprovalListPage />,
  },
  {
    breadcrumb: 'GCPR Materials',
    path: 'gcpr-materials',
    element: <OfferGCPRMaterialListPage />,
  },
  {
    breadcrumb: '',
    path: 'tasks',
    element: <OfferTaskDashboard />,
  },

  {
    breadcrumb: OfferBreadcrumb,
    path: ':id',
    element: <EditOffer />,
  },
]

export default offerRoutes
